import { DropdownMenu } from '@/components/commons'
import { IUser } from '@/interfaces/user'
import { ThreeDotsIcon } from '@/public/assets/v2/images/icons'
import { useProfile } from 'containers/profile/hooks/useProfile'
import { useEffect, useState } from 'react'
import { ModalRemoveConnection } from './ModalRemoveConnection'
import { ModalBloackConnection } from './ModalBlockConnection'
import {
  useBlockConnection,
  useRemoveConnection,
  useUnblockConnection,
} from 'containers/profile-network/hooks/useConnectionsActions'
import { BlockConnectionReason } from 'containers/profile/types/connections'
import { useUser } from 'containers/user/hooks/useUser'
import { validateConnectionType } from 'containers/profile/utilities/profile'
import { ModalUnblockConnection } from './ModalUnblockConnection'
import { ProfileRelationType } from 'containers/profile/types/profile'
import { User } from 'containers/user/types/user'

interface BlockRemoveConnectionProps {
  profile?: IUser | User
  setRemovingOrBlockingConnection?: (value: boolean) => void
}
export const BlockRemoveConnection = ({
  profile,
  setRemovingOrBlockingConnection,
}: BlockRemoveConnectionProps) => {
  const { user } = useUser()
  const { profile: currentProfile } = useProfile()
  const { mutateAsync: removeConnection, isLoading: removingConnection } =
    useRemoveConnection()
  const { mutateAsync: blockConnection, isLoading: blockingConnection } =
    useBlockConnection()
  const { mutateAsync: unblockConnection, isLoading: unblockingConnection } =
    useUnblockConnection()

  const [showRemoveConnectionModal, setShowRemoveConnectionModal] =
    useState(false)
  const [showBlockConnectionModal, setShowBlockConnectionModal] =
    useState(false)
  const [showUnblockConnectionModal, setShowUnblockConnectionModal] =
    useState(false)

  const profileId = profile?.id || currentProfile?.id
  const relationType = validateConnectionType({
    user,
    profile: profile || currentProfile,
  })

  useEffect(() => {
    if (profileId) {
      setShowRemoveConnectionModal(false)
      setShowBlockConnectionModal(false)
      setShowUnblockConnectionModal(false)
    }
    setRemovingOrBlockingConnection &&
      setRemovingOrBlockingConnection(
        removingConnection || blockingConnection || unblockingConnection
      )
  }, [
    removingConnection,
    blockingConnection,
    setRemovingOrBlockingConnection,
    profileId,
    unblockingConnection,
    setShowUnblockConnectionModal,
  ])

  const handleBlockConnection = async (reason: BlockConnectionReason) => {
    await blockConnection({
      blockedUserId: profileId,
      reason,
    })
  }

  return (
    <>
      <ModalRemoveConnection
        showModal={showRemoveConnectionModal}
        closeModal={() => setShowRemoveConnectionModal(false)}
        removeConnection={() =>
          removeConnection({ userIdReceivedRequest: profileId })
        }
      />

      <ModalBloackConnection
        showModal={showBlockConnectionModal}
        closeModal={() => setShowBlockConnectionModal(false)}
        blockConnection={handleBlockConnection}
      />

      <ModalUnblockConnection
        showModal={showUnblockConnectionModal}
        closeModal={() => setShowUnblockConnectionModal(false)}
        unblockConnection={() =>
          unblockConnection({ unblockedUserId: profileId })
        }
      />

      <DropdownMenu>
        <DropdownMenu.Trigger>
          <div className="hover__bg-tertiary py-4 px-2 cursor-pointer">
            <ThreeDotsIcon
              style={{ transform: 'rotate(90deg)' }}
              className="text-secondary text-14"
            />
          </div>
        </DropdownMenu.Trigger>

        <DropdownMenu.Content align="end" sideOffset={20} alignOffset={-10}>
          {relationType === ProfileRelationType.BLOCKED ? (
            <DropdownMenu.Item
              onClick={() => setShowUnblockConnectionModal(true)}
            >
              <span>Unblock Connection</span>
            </DropdownMenu.Item>
          ) : (
            <>
              <DropdownMenu.Item
                onClick={() => setShowRemoveConnectionModal(true)}
              >
                <span> Remove Connection</span>
              </DropdownMenu.Item>
              <DropdownMenu.Item
                onClick={() => setShowBlockConnectionModal(true)}
              >
                <span>Block Connection</span>
              </DropdownMenu.Item>
            </>
          )}
        </DropdownMenu.Content>
      </DropdownMenu>
    </>
  )
}
